// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

:root {
  overflow-x: hidden;
  height: 100%;
}

* {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  box-sizing: border-box;
  outline: none;
}

*:focus {
  outline: none;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  min-height: 100%;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  body {
    font-size: 1.2rem;
  }
}
@media (max-width: 576px) {
  body {
    font-size: 1.1rem;
  }
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.container {
  width: 100%;
  max-width: 1200px;
  padding: 15px;
  box-sizing: border-box;
  margin: 0 auto;
}

hr.style-one {
  width: 90%;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

hr.style-two {
  width: 90%;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));
}

hr.style-three {
  width: 90%;
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: #999;
}

.error-color {
  color: #aa004f;
}

/**  **/
.profile-wrapper,
.shifts-dashboard,
.profile-components,
.profile-page-content--show-tab { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 1s;
  min-height: calc(100vh - 230px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
/* Safari, Chrome and Opera > 12.1 */
/* Internet Explorer */
/* Opera < 12.1 */
.profile-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: white;
}
.profile-header .deco-stripe {
  height: 40px;
  background-position: center;
  box-shadow: rgba(0, 0, 0, 0.15) 0 3px 3px 0;
}
.profile-header .top-icons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin: 0 50px;
}
.profile-header .top-icons .left-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.profile-header .top-icons .left-icons .logo-link img {
  padding: 10px;
  width: 55%;
  min-width: 100px;
}
.profile-header .top-icons .right-icons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.profile-header .top-icons .right-icons .bell-button {
  position: relative;
  cursor: pointer;
  border: none;
  background-color: white;
}
.profile-header .top-icons .right-icons .bell-button .bell-icon-wrap {
  background-color: #f8f7f7;
  border-radius: 50%;
}
.profile-header .top-icons .right-icons .bell-button .bell-icon-wrap img.bell-img {
  width: 40px;
  height: 40px;
  padding: 8px;
}
.profile-header .top-icons .right-icons .bell-button .bell-icon-dropdown {
  position: absolute;
  left: -128px;
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}
.profile-header .top-icons .right-icons .bell-badge {
  z-index: 1;
  position: absolute;
  padding: 5px;
  margin-left: -15px;
  border-radius: 50%;
  background-color: #aa004f;
  color: white;
  font-size: 12px;
  height: 20px;
  width: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}
.profile-header .top-icons .right-icons .profile-icon {
  position: relative;
  cursor: pointer;
  border: none;
  background-color: white;
}
.profile-header .top-icons .right-icons .profile-icon img.profile-img {
  width: 60px;
  height: 60px;
  border: 3px solid #aa004f;
  border-radius: 50%;
  margin-left: 30px;
}
.profile-header .top-icons .right-icons .profile-icon .profile-icon-dropdown {
  position: absolute;
  bottom: -160px;
  left: -40px;
  font-family: "Roboto", sans-serif;
  font-weight: 100;
}
@media (max-width: 768px) {
  .profile-header .top-icons .right-icons .profile-icon .profile-icon-dropdown {
    bottom: -175px;
    left: -67px;
  }
}
.profile-header .center-icons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0 0 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.profile-header .center-icons .profile-icon-center img.profile-img-center {
  width: 80px;
  height: 80px;
  border: 3px solid #ffffff;
  border-radius: 50%;
}
.profile-header .center-icons h2 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
}
.profile-header .bottom-icons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100px;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  gap: 60px;
}
.profile-header .bottom-icons .bottom-icon-link {
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  text-decoration: none;
  color: #000000;
}
.profile-header .bottom-icons .bottom-icon-link--highlighted {
  text-decoration: underline;
  text-underline-offset: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  text-decoration-color: #aa004f;
}
@media (max-width: 992px) {
  .profile-header .profile-header {
    flex-direction: column;
    height: auto;
    padding: 25px 0;
  }
  .profile-header .profile-header .logo-link {
    position: initial;
  }
  .profile-header .profile-header .rs-body .container .section {
    padding: 15px;
  }
}

@media (max-width: 768px) {
  .profile-header .top-icons {
    height: auto;
    margin: 0 15px 0;
    padding: 15px 0;
  }
  .profile-header .top-icons .left-icons .logo-link {
    overflow: hidden;
    display: flex;
    width: 55px;
    height: 55px;
    justify-content: center;
  }
  .profile-header .top-icons .left-icons .logo-link img {
    width: 55px;
    height: 55px;
  }
  .profile-header .top-icons .right-icons .profile-icon img.profile-img {
    width: 45px;
    height: 45px;
    margin-left: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/components/Header/styles.scss","webpack://./src/css/general.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;ACpBA;EACE,kBAAA;EACA,YAAA;ADuBF;;ACrBA;EFJE,iCAAA;EACA,gBEIqB;EACrB,sBAAA;EACA,aAAA;ADyBF;;ACvBA;EACE,aAAA;AD0BF;;ACxBA;;EAEE,SAAA;EACA,UAAA;AD2BF;;ACzBA;EACE,gBAAA;EACA,iBFTO;ACqCT;AC1BE;EAJF;IAKI,iBFbK;EC0CP;AACF;AC5BE;EAPF;IAQI,iBFjBK;ECgDP;AACF;;AC5BA;EF7BE,iCAAA;EACA,gBE6BqB;ADgCvB;;AC7BA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;ADgCF;;AC7BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,6DAAA;ADgCF;;AC9BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,oGAAA;ADiCF;;AC/BA;EACE,UAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;ADkCF;;AChCA;EACE,cC3DO;AF8FT;;AC9BA,OAAA;AACA;;;kCAIE,oCAAA,EACA,iBAAA,EACA,sBAAA,EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;ADiCF;;AC9BA;EACE;IAAO,UAAA;EDkCP;ECjCA;IAAO,UAAA;EDoCP;AACF;AClCA,iBAAA;AAMA,oCAAA;AAMA,sBAAA;AAMA,iBAAA;ADrGA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;AA2JF;AA1JE;EACE,YAAA;EACA,2BAAA;EACA,2CAAA;AA4JJ;AA1JE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AA4JJ;AA3JI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA6JN;AA3JQ;EACE,aAAA;EACA,UAAA;EACA,gBAAA;AA6JV;AAxJI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA0JN;AAxJM;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AA0JR;AAxJQ;EACE,yBEzCD;EF0CC,kBAAA;AA0JV;AAzJU;EACE,WAAA;EACA,YAAA;EACA,YAAA;AA2JZ;AAxJQ;EACE,kBAAA;EAEA,YAAA;EDzDR,iCAAA;EACA,gBCyD6B;AA0J/B;AAvJM;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBE3DE;EF4DF,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;ED1EN,iCAAA;EACA,gBC2E2B;AAyJ7B;AAvJM;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AAyJR;AAvJQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAyJV;AAvJQ;EACE,kBAAA;EACA,cAAA;EACA,WAAA;ED9FR,iCAAA;EACA,gBC8F6B;AA0J/B;AAzJU;EALF;IAMI,cAAA;IACA,WAAA;EA4JV;AACF;AAvJE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAyJJ;AAvJM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAyJR;AAtJI;EDzHF,iCAAA;EACA,gBCyHyB;EACrB,cAAA;EACA,yBAAA;AAyJN;AAtJE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;AAwJJ;AAvJI;EACE,eAAA;ED3IJ,iCAAA;EACA,gBC2IyB;EACrB,qBAAA;EACA,cAAA;AA0JN;AAzJM;EACE,0BAAA;EACA,2BAAA;EDjJN,iCAAA;EACA,gBCiJ2B;EACrB,8BEjJC;AF6ST;AAxJE;EACE;IACE,sBAAA;IACA,YAAA;IACA,eAAA;EA0JJ;EAzJI;IACE,iBAAA;EA2JN;EAtJQ;IACE,aAAA;EAwJV;AACF;;AAlJA;EAEI;IACE,YAAA;IACA,gBAAA;IACA,eAAA;EAoJJ;EAlJM;IACE,gBAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;EAoJR;EAnJQ;IACE,WAAA;IACA,YAAA;EAqJV;EA/IQ;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAiJV;AACF","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints.scss\";\n@import \"../../css/colors.scss\";\n@import \"../../css/general.scss\";\n\n.profile-header {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  background-color: white;\n  .deco-stripe {\n    height: 40px;\n    background-position: center;\n    box-shadow: rgba(0, 0, 0, 0.15) 0 3px 3px 0;\n  }\n  .top-icons {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: center;\n    align-items: center;\n    margin: 0 50px;\n    .left-icons {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      align-content: center;\n      .logo-link {\n        img {\n          padding: 10px;\n          width: 55%;\n          min-width: 100px;\n          // height: 55%;\n        }\n      }\n    }\n    .right-icons {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      align-content: center;\n\n      .bell-button {\n        position: relative;\n        cursor: pointer;\n        border: none;\n        background-color: white;\n\n        .bell-icon-wrap {\n          background-color: $color9;\n          border-radius: 50%;\n          img.bell-img {\n            width: 40px;\n            height: 40px;\n            padding: 8px;\n          }\n        }\n        .bell-icon-dropdown {\n          position: absolute;\n          // bottom: -45px;\n          left: -128px;\n          @include font-roboto(100);\n        }\n      }\n      .bell-badge {\n        z-index: 1;\n        position: absolute;\n        padding: 5px;\n        margin-left: -15px;\n        border-radius: 50%;\n        background-color: $color12;\n        color: white;\n        font-size: 12px;\n        height: 20px;\n        width: 18px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n\n        @include font-roboto(100);\n      }\n      .profile-icon {\n        position: relative;\n        cursor: pointer;\n        border: none;\n        background-color: white;\n\n        img.profile-img {\n          width: 60px;\n          height: 60px;\n          border: 3px solid $color12;\n          border-radius: 50%;\n          margin-left: 30px;\n        }\n        .profile-icon-dropdown {\n          position: absolute;\n          bottom: -160px;\n          left: -40px;\n          @include font-roboto(100);\n          @media (max-width: $md) {\n            bottom: -175px;\n            left: -67px;\n          }\n        }\n      }\n    }\n  }\n  .center-icons {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 15px 0 0 0;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    .profile-icon-center {\n      img.profile-img-center {\n        width: 80px;\n        height: 80px;\n        border: 3px solid #ffffff;\n        border-radius: 50%;\n      }\n    }\n    h2 {\n      @include font-roboto(600);\n      color: #ffffff;\n      text-transform: uppercase;\n    }\n  }\n  .bottom-icons {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    height: 100px;\n    width: auto;\n    max-width: 100%;\n    margin: 0 auto;\n    gap: 60px;\n    .bottom-icon-link {\n      cursor: pointer;\n      @include font-roboto(100);\n      text-decoration: none;\n      color: #000000;\n      &--highlighted {\n        text-decoration: underline;\n        text-underline-offset: 20px;\n        @include font-roboto(500);\n        text-decoration-color: $color6;\n      }\n    }\n  }\n  @media (max-width: $lg) {\n    .profile-header {\n      flex-direction: column;\n      height: auto;\n      padding: 25px 0;\n      .logo-link {\n        position: initial;\n      }\n\n      .rs-body {\n        .container {\n          .section {\n            padding: 15px;\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: $md) {\n  .profile-header {\n    .top-icons {\n      height: auto;\n      margin: 0 15px 0;\n      padding: 15px 0;\n      .left-icons {\n        .logo-link {\n          overflow: hidden;\n          display: flex;\n          width: 55px;\n          height: 55px;\n          justify-content: center;\n          img {\n            width: 55px;\n            height: 55px;\n          }\n        }\n      }\n      .right-icons {\n        .profile-icon {\n          img.profile-img {\n            width: 45px;\n            height: 45px;\n            margin-left: 15px;\n          }\n        }\n      }\n    }\n  }\n\n}","@import \"fonts\";\n@import \"breakpoints\";\n@import \"colors\";\n:root {\n  overflow-x: hidden;\n  height: 100%;\n}\n* {\n  @include font-roboto(200);\n  box-sizing: border-box;\n  outline: none;\n}\n*:focus {\n  outline: none;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  min-height: 100%;\n  font-size: $font-lg;\n  \n  @media (max-width: $md){\n    font-size: $font-md;\n  }\n  @media(max-width:$sm){\n    font-size: $font-sm;\n  }\n}\n\nh1, h2, h3 ,h4, h5, h6 {\n  @include font-roboto(400);\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  padding: 15px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\nhr.style-one {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background: #333;\n  background-image: linear-gradient(to right, #ccc, #333, #ccc);\n}\nhr.style-two {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));\n}\nhr.style-three {\n  width: 90%;\n  border: 0;\n  border-bottom: 1px dashed #ccc;\n  background: #999;\n}\n.error-color {\n  color: $color6;\n}\n\n\n\n/**  **/\n.profile-wrapper,\n.shifts-dashboard,\n.profile-components,\n.profile-page-content--show-tab {\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n  -o-animation: fadein 1s; /* Opera < 12.1 */\n  animation: fadein 1s;\n  min-height: calc(100vh - 230px);\n}\n\n@keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
